import Chats from './Chats';

export default Chats;
